export const small = '576px';

export const medium = '768px';

export const large = '992px';

export const xLarge = '1200px';

const breakpoints = {
  small,
  medium,
  large,
  xLarge,
};

export default breakpoints;
